import "./ProductContainer.css"
import "./FreeProductContainer.css"
import {useCms} from "../../../context/CmsContext";
import CmsHelper, {PickProgramPageHelper} from "../../Utilities/CmsHelpers";
import {useTranslation} from "react-i18next";
import React from "react";

export default function FreeProductContainer({product, onNext, setSelected}) {
    const {t} = useTranslation()
    const {pickProgramData} = useCms();
    const programInfo = PickProgramPageHelper.getProgramInfo(PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.DEFAULT));
    const cmsData = PickProgramPageHelper.getProgram(programInfo, product.displayName)[0];
    let usps = [
        ...(cmsData.usps?.usp || [])
    ];

    return (<div className={`pick-product-wrapper freeLandscape`}
                 style={{backgroundColor: cmsData.displayName.colorCode + "26"}}
                 onClick={setSelected}
                 id={product.displayName}>
                <div className={"pick-product-lower"}>
                    <div className={"pick-product-usps"}>
                        <ul>
                            {usps.map((item, itemIndex) => {
                                return <li key={itemIndex}>
                                    {item.value}
                                </li>
                            })}
                        </ul>
                    </div>
                </div>
                <button className={"pick-product-cta"} onClick={onNext}>{t("pickProductCTA")}</button>
    </div>)
}